import { Autocomplete, FormControl, TextField } from '@mui/material'
import { GangResponseDto } from '@operations/app/api'
import {
  EquipmentOperatorLandingFormData,
  EquipmentOperatorLandingUIStore,
} from '@operations/features/equipmentOperator/stores/equipment-operator-landing.ui-store'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
  uiStore: EquipmentOperatorLandingUIStore
}

export const SelectGang = observer(({ uiStore }: Props) => {
  const { t } = useTranslate()

  const { control } = useFormContext<EquipmentOperatorLandingFormData>()

  return (
    <Controller
      control={control}
      name={'gang'}
      rules={{ required: true }}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth>
          <Autocomplete
            options={uiStore.gangOptions}
            value={value}
            onChange={(_: any, newValue: GangResponseDto | null) => {
              onChange(newValue)
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={option => option.name ?? ''}
            fullWidth
            data-cy='operator-select-gang-field'
            renderInput={params => <TextField {...params} label={t('gang', 'Gang')} required />}
          />
        </FormControl>
      )}
    />
  )
})
